var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-switch',_vm._b({attrs:{"default-checked":""},on:{"change":_vm.onChange},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}},'a-switch',_vm.instance,false))}
var staticRenderFns = []

export { render, staticRenderFns }